// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"2937":"f7d7bc3c48adf4a0","7127":"b85504ff25b173e8"}[chunkId] + ".js";
};